
<template>
<div>
  <multiselect v-model="mutableSelectedPackages" :show-labels="false" placeholder="Verpackungen auswählen" :options="allpackages" :multiple="true"  track-by="id"  label="displayedZohoCode"  :close-on-select="true"></multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const axios = require('axios');

    export default {
      props: ['selectedpackages'],
      components: {
      	Multiselect
    	},
        data(){
          return {
            allpackages: [],
            mutableSelectedPackages: this.selectedpackages,
          }
        },
        watch: {
          selectedpackages(val) {
            console.log("CHANEE2");
            console.log(val);
              this.mutableSelectedPackages = val;
          },
          mutableSelectedPackages(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          //Get Spiele
          //Get-Categories
          this.getPackages();


        },
        methods: {
          getPackages: function() {
            var _this = this;
            axios.get('/api/packagesnew', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
              _this.allpackages = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          }
        },
      }

</script>
